<div (click)="copyToClipboard(this.text)" class="terminal">
    <p-toast></p-toast>
    <span class="code" >
        {{text}}
    </span>
    <span  class="copy"><img src="../../../../assets/icons/copy-text.svg" /></span>
</div>
